// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__WhGJv","storeIcon":"styles_storeIcon__sm6kf","slide-in-out":"styles_slide-in-out__WPzrO","fade-in-out":"styles_fade-in-out__lYgVY"};